export type FooterLink = {
  label: string
  to: string
  /** External production URLs open in a new tab. */
  external?: boolean
}

export type FooterColumn = {
  heading: string
  links: FooterLink[]
}

export const footerColumns: FooterColumn[] = [
  {
    heading: 'Solutions',
    links: [
      { label: 'Website strategy and design', to: '/#solutions' },
      { label: 'Ecommerce', to: '/#ecommerce' },
      { label: 'SEO and paid search', to: '/#seo' },
      { label: 'Integrations and automation', to: '/#solutions' },
      { label: 'Hosting and ongoing support', to: '/#ongoing' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Portfolio', to: '/portfolio' },
      { label: 'Why WebsiteForge', to: '/#why-custom' },
      { label: 'How pricing works', to: '/pricing' },
      { label: 'Start a project conversation', to: '/#get-started' },
    ],
  },
]

/** TODO (content): confirm these production URLs before launch. */
export const legalLinks: FooterLink[] = [
  { label: 'Privacy policy', to: 'https://www.websiteforge.com/privacy-policy.html', external: true },
  { label: 'Terms of use', to: 'https://www.websiteforge.com/terms-of-use.html', external: true },
  { label: 'Sitemap', to: 'https://www.websiteforge.com/sitemap.xml', external: true },
]
